
































































import {
  Vue,
  Component,
  Prop,
  Watch
} from "@/shared/vuepack";
import { HsaStoreInfo } from "@/shared/types";
import Button from "@/shared/components/ui/Button.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useHsaStoreInfoStore } from "@/employee/store/hsaStoreInfo";
import { openUrl } from "@/shared/urlHelper";
@Component({
  components: {
    Button,
    GenericLoadingSpinner
  }
})
export default class HsaStoreCarouselWidget extends Vue {
  custodianStore = useCustodianSettingsStore();
  useHsaStoreInfoStore = useHsaStoreInfoStore();

  currentLogoImageUrl = "";
  currentIndex = 0;
  timer;

  clickForward (): void {
    this.next();
  }
  clickBackward (): void {
    this.previous();
  }
  linkNavigate (url): void {
    openUrl(url);
  }
  resetTimer () {
    this.stopTimer();
    this.startTimer();
  }
  stopTimer () {
    window.clearInterval(this.timer);
    this.timer = null;
  }
  startTimer () {
    this.timer = setInterval(() => {
      this.next();
    }, this.currentHsaStoreInfo.delayInSeconds * 1000);
  }
  next () {
    if (this.currentIndex === this.hsaStoreInfos.length - 1) {
      this.currentIndex = 0;
    }
    else {
      this.currentIndex++;
    }
  }
  previous () {
    if (this.currentIndex === 0) {
      this.currentIndex = this.hsaStoreInfos.length - 1;
    }
    else {
      this.currentIndex--;
    }
  }
  async openShop () {
    await this.custodianStore.logHsaStoreWidgetClick(true);
  }
  async openEligibility () {
    await this.custodianStore.logHsaStoreWidgetClick(false);
  }
  get isLoaded () {
    return this.useHsaStoreInfoStore.isStoresLoaded;
  }
  get hsaStoreInfos (): HsaStoreInfo[] {
    return this.useHsaStoreInfoStore.hsaStoreInfos;
  }
  get currentHsaStoreInfo (): HsaStoreInfo {
    return this.hsaStoreInfos[this.currentIndex];
  }

  get hasMultipleHsaStores (): boolean {
    return this.hsaStoreInfos.length > 1;
  }

  @Watch("currentHsaStoreInfo")
  resetTime () {
    this.resetTimer();
  }
  mounted () {
    if (this.hasMultipleHsaStores) {
      this.startTimer();
    }
  }

  get logoImage () {
    return `data:image/png;base64,${this.currentHsaStoreInfo.logo}`;
  }
}
